import React, { useEffect } from "react";

export default function FormEmbed() {
  useEffect(() => {
    if (/ReactSnap/i.test(window.navigator.userAgent)) return;

    const existingScript = document.getElementById("tally-embed-script");
    if (existingScript) return;

    const script = document.createElement("script");
    script.id = "tally-embed-script";
    script.src = "https://tally.so/widgets/embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <iframe
      data-tally-src="https://tally.so/embed/VLJRpE?hideTitle=1&transparentBackground=1&dynamicHeight=1"
      loading="lazy"
      width="100%"
      height="600"
      style={{
        border: "none",
        outline: "none",
        background: "transparent",
      }}
      title="Submit Inquiry"
    />
  );
}
